module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scheduled-post"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": _vm.colWidths[0]
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.post.message))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": _vm.colWidths[1]
    }
  }, [_c('span', {
    staticClass: "post-time"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }, [_vm._v(" ")]), _vm._v(" "), _c('em', [_vm._v(_vm._s(_vm.postTimestamp))])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": _vm.colWidths[0]
    }
  }, [(_vm.containsMedia) ? _c('el-tooltip', {
    attrs: {
      "content": "Contains Media",
      "placement": "bottom"
    }
  }, [_c('span', {
    staticClass: "contains-media"
  }, [_c('i', {
    staticClass: "fa fa-image"
  })])]) : _c('span', {
    staticClass: "pull-left"
  }, [_vm._v(" ")])], 1), _vm._v(" "), _c('el-col', [_c('span', {
    staticClass: "post-controls"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "Edit",
      "placement": "bottom"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    on: {
      "click": _vm.handleEditPost
    }
  })]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "Delete",
      "placement": "bottom"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    on: {
      "click": _vm.handleDeletePost
    }
  })])], 1), _vm._v(" "), (_vm.channels.length) ? _c('div', _vm._l((_vm.channelTypes), function(channel) {
    return _c('el-tooltip', {
      key: channel
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, _vm._l((_vm.getChannelHandlesByType(channel)), function(handle) {
      return _c('span', {
        key: handle,
        staticClass: "social-icons"
      }, [_vm._v("\n              " + _vm._s(handle) + "\n              "), _c('br')])
    }), 0), _vm._v(" "), (channel) ? _c('social-icon', {
      staticClass: "channel-icon",
      attrs: {
        "type": channel
      }
    }) : _vm._e()], 1)
  }), 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67d90b4d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/social/ScheduledPost.vue
// module id = 3318
// module chunks = 3